import { apiCaller } from '@/api/apiCaller';
import { IFunctionality } from '@/modules/functionality/models';
import { apihost } from '@/api/urls';

const getAll = (isOnlyActive: boolean) => apiCaller.getParams('/functionality/', apihost, { IsOnlyActive: isOnlyActive });
const getAllGrouped = () => apiCaller.get('/functionality/grouped', apihost);
const addFunctionality = (system: IFunctionality) => apiCaller.post('/functionality/save', apihost, system);
const updateFunctionality = (system: IFunctionality) => apiCaller.put('/functionality/update', apihost, system);


export const functionalityApi = {
    getAll,
    getAllGrouped,
    addFunctionality,
    updateFunctionality,
};
